import GraphCommand from './GraphCommand.js';

/** One edit of a page's event/action node graph (`page.logic`); see GraphCommand. */
export default class LogicGraphCommand extends GraphCommand {
    constructor({ pageUuid, diff, description = 'Edit logic', mergeKey = null }) {
        super({ graphKey: 'logic', type: 'LogicGraph', pageUuid, diff, description, mergeKey });
    }
}
